const paths = {
  uploadAudio: "/lesson_voice_recordings/create",
}

export default {
  sendAudio: async (axios, payload) => {
    const formData = new FormData()
    formData.append("lesson_id", payload.lesson_id)
    formData.append("file", payload.audio)

    const res = await axios.post(paths.uploadAudio, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return res
  },
}
